import { createBusiness } from '../../../data/repositories/businessRepository.js';

export const registerBusiness = (payload) => createBusiness(payload);
